/*
 * @Author: huangzq
 * @Date: 2020-04-09 20:17:21
 * @Last Modified by: zhouwei
 * @Last Modified time: 2020-06-06 18:29:52
 * @Desc: 员工分析列表页面
*/
<template>
  <div class="analysi-list">
    <!-- 顶部栏 -->
    <div class="top-line">
      <div class="left">
        <!-- 公司id为NA，根据需要自行转换 -->
        <dept-member-select-biz
          v-model="dmList"
          width="220"
          placeholder="查找部门、员工"
          can-select-company
          @change-data="handelOnDeptMemberSelectChange"
        />
      </div>
      <div class="right">
        <div class="update-time">
          当前数据更新时间：{{ lastUpdateTime }}
        </div>
        <!-- 导出按钮 -->
        <export-xlsx :api="apiConfig" />
      </div>
    </div>

    <!-- 员工分析表格 -->
    <div class="table-wrapper">
      <ListBiz
        :data="tableData"
        :config="tableConfig"
        :page="apiParams.page"
        :total="total"
        :page-size="apiParams.size"
        :table-loading="tableLoading"
        @sort-change="handelOnSortChange"
        @on-current-change="handleOnCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { MBASVCAPIS } from '@api'

import TableConfig from './components/index.js'
import ExportXlsx from '@components/export-xlsx/index.vue'
import DeptMemberSelectBiz from '@components/dept-member-select-biz'

export default {
  name: 'AnalysiList',
  components: { ExportXlsx, DeptMemberSelectBiz },
  data () {
    return {
      tableLoading: true,
      // 当前数据更新时间
      lastUpdateTime: '2019-02-12 12:23',
      // 员工分析列表数据
      tableData: [],
      // 获取员工分析列表接口参数
      apiParams: {
        page: 1,
        size: 10,
        // true:全公司.false:根据部门和员工筛选
        all: true,

        // 默认按学习任务的完成数倒序排列
        asc: false, // false 降序，true：升序
        sortField: 'mission.completeCount', // 排序字段，默认 mission.completeCount

        // 部门 支持多选
        departmentId: [],
        // 员工 支持多选
        userId: []
      },
      // 列表总条数
      total: 0,

      // 表格的配置
      tableConfig: TableConfig,

      dmList: {
        // 部门列表
        dept: [],
        // 成员列表
        member: []
      }

    }
  },
  computed: {
    // 导出按钮的配置
    apiConfig () {
      return {
        name: MBASVCAPIS.EmployeeAnalysisApi.employeeAnalysisExportPost,
        params: this.apiParams
      }
    }
  },
  created () {
    this.getDataByApi()
  },
  methods: {
    // 通过接口获取员工分析列表数据
    async getDataByApi () {
      this.tableLoading = true
      const res = await MBASVCAPIS.EmployeeAnalysisApi.employeeAnalysisListPost(this.apiParams)

      if (res.success) {
        this.tableData = res.data.list
        this.lastUpdateTime = res.data.lastUpdateTime
        this.total = res.data.total
      }
      this.tableLoading = false
    },

    // 部门、员工选择器change事件
    handelOnDeptMemberSelectChange ({ departmentIds, userIds, all }) {
      this.apiParams.departmentId = departmentIds
      this.apiParams.userId = userIds
      // true:全公司.false:根据部门和员工筛选
      // 当要进行部门、员工筛选时，该字段必须为false
      this.apiParams.all = all
      // 搜索时重置页数
      this.apiParams.page = 1
      this.getDataByApi()
    },

    // 排序change事件
    handelOnSortChange ({ column, order }) {
      if (order) {
        // 当排序字段有值时，则根据值、字段进行排序
      // 使用labelClassName的值来当作接口参数sortField的值
        this.apiParams.sortField = column.labelClassName
        this.apiParams.asc = order === 'ascending'
      } else {
        // 当排序字段没有值时，则使用默认值、字段进行排序
        this.apiParams.sortField = 'mission.completeCount'
        this.apiParams.asc = false
      }

      this.getDataByApi()
    },

    // 分页change事件
    handleOnCurrentChange (page) {
      this.apiParams.page = page
      this.getDataByApi()
    }
  }
}
</script>

<style lang='scss' scoped>
.analysi-list {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  overflow: hidden;

  .top-line {
    display: flex;
    justify-content: space-between;
    // margin-bottom: 20px;
    margin-bottom: 10px;

    .right {
      display: flex;
      align-items: center;

      .update-time {
        margin-right: 16px;
        font-size: 13px;
        color: #595959;
      }
    }
  }

  .table-wrapper {
    flex: 1;
    // 该高度没啥用的，但是不写的话，flex:1不生效
    height: 0;
  }
}
</style>
